
var apiUrl = ''

var cntextPath = "/bid";

// 前端后缀
var webCntextPath = "/bidc"

function getBaseUrl() {
    var baseUrl = ""
    if (process.env.NODE_ENV === "production") {
        baseUrl = webCntextPath
    }
    return baseUrl;
}

//var version = "dev";
var version = "";

function getVersion() {
    return version;
}

export {
    apiUrl,
    cntextPath,
    getBaseUrl,
    getVersion
}



// WEBPACK FOOTER //
// ./src/api/requestUrl.js